module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "grey lighten-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "primary elevation-0",
    attrs: {
      "dark": "",
      "extended": ""
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "lg8": "",
      "offset-xs1": "",
      "offset-lg2": ""
    }
  }, [_c('v-card', {
    staticClass: "card--flex-toolbar"
  }, [_c('v-app-bar', {
    staticClass: "white",
    attrs: {
      "flat": "",
      "prominent": ""
    }
  }, [(_vm.returnShopPortal) ? _c('v-app-bar-title', {
    staticClass: "body-2 grey--text"
  }, [(_vm.returnShopPortal.active) ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-dialog', _vm._g({
          attrs: {
            "width": "500"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "color": "green"
                }
              }, on), [_vm._v("fiber_manual_record")])]
            }
          }], null, true),
          model: {
            value: (_vm.dialog),
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        }, on), [_vm._v(" "), _c('v-card', [_c('v-card-title', {
          staticClass: "headline",
          attrs: {
            "primary-title": ""
          }
        }, [_vm._v("\n                      Return Shop deactivation\n                    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                      Please enter the name "), _c('b', [_vm._v(_vm._s(_vm.returnShopPortal.uuid))]), _vm._v(" in the following text-field to deactivate\n                      this return-shop.\n\n                      "), _c('v-text-field', {
          attrs: {
            "label": "return-shop to deactivate",
            "value": "",
            "single-line": ""
          },
          model: {
            value: (_vm.returnShopDeleteConfirmation),
            callback: function($$v) {
              _vm.returnShopDeleteConfirmation = $$v
            },
            expression: "returnShopDeleteConfirmation"
          }
        })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "primary",
            "disabled": _vm.returnShopDeleteConfirmation !== _vm.returnShopPortal.uuid
          },
          on: {
            "click": function($event) {
              _vm.setReturnShopPortalActive(false);
              _vm.dialog = false
            }
          }
        }, [_vm._v("deactivate")])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("\n                      Rename Return Shop\n                    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                      Please enter the new name...\n\n                      "), _c('v-text-field', {
          attrs: {
            "label": "new return-shop name",
            "value": "",
            "single-line": ""
          },
          model: {
            value: (_vm.returnShopRenameConfirmation),
            callback: function($$v) {
              _vm.returnShopRenameConfirmation = $$v
            },
            expression: "returnShopRenameConfirmation"
          }
        })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "primary",
            "disabled": _vm.returnShopRenameConfirmation == ''
          },
          on: {
            "click": function($event) {
              _vm.renameReturnShopPortal(_vm.returnShopRenameConfirmation);
              _vm.dialog = false
            }
          }
        }, [_vm._v("rename")])], 1)], 1)], 1)]
      }
    }], null, false, 4215328908)
  }, [_vm._v(" "), _c('span', [_vm._v("Umbenennen")])]) : _c('v-icon', {
    attrs: {
      "color": "red"
    },
    on: {
      "click": function($event) {
        return _vm.setReturnShopPortalActive(true)
      }
    }
  }, [_vm._v("fiber_manual_record")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.url
    }
  }, [_vm._v(_vm._s(_vm.url))])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._l((_vm.menu), function(item) {
    return _c('v-tooltip', {
      key: item.href,
      attrs: {
        "top": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            attrs: {
              "icon": "",
              "href": item.href
            }
          }, on), [_c('v-icon', {
            class: {
              'blue--text': item.isActive,
              'grey--text text--darken-1': !item.isActive
            }
          }, [_vm._v(_vm._s(item.icon))])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])])
  })], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "min-height": "200px"
    }
  }, [(_vm.done) ? _c('router-view') : _c('div', [_vm._v("loading..")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/prod-isrs-frontend-mb_master/~/vue-loader/lib/template-compiler?{"id":"data-v-32614098"}!/export/jenkins/workspace/prod-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=template&index=0!./client/views/returnShopPortals/GetOuter.vue
// module id = 929
// module chunks = 1